const STOCKHOLM_DATE_TIME_OPTIONS = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "Europe/Stockholm",
};

const STOCKHOLM_TIME_OPTIONS = {
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "Europe/Stockholm",
};

function toValidDate(value) {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date;
}

export function formatDateTimeNoSeconds(value, fallback = "") {
  const date = toValidDate(value);
  if (!date) {
    return fallback;
  }

  return date.toLocaleString("sv-SE", STOCKHOLM_DATE_TIME_OPTIONS);
}

export function formatTimeNoSeconds(value = new Date(), fallback = "") {
  const date = toValidDate(value);
  if (!date) {
    return fallback;
  }

  return date.toLocaleTimeString("sv-SE", STOCKHOLM_TIME_OPTIONS);
}